module.exports = __webpack_public_path__ + "static/media/icon-piece6-4.53ffcb45.png";